import React from "react";
import PropTypes from "prop-types";
import {
    Button
} from "react-bootstrap";

function CourseAddLessonCard({ onClick }) {
    return (
        <div className="card card-course-lesson-add text-muted" onClick={ onClick }>
            <div className="card-body">
                <div className="d-flex align-items-center">
                    <div className="mr-2">
                        <Button
                            variant="light"
                            onClick={ onClick }
                        >
                            <i className="fas fa-plus"/>
                        </Button>
                    </div>
                    <div>
                        Nieuwe les toevoegen
                    </div>
                </div>
            </div>
        </div>
    )
}
CourseAddLessonCard.propTypes = {
    onClick: PropTypes.func
}

export default React.memo(CourseAddLessonCard);
